export type CourseProgramId = 'python' | 'javascript' | 'computer-literacy' | 'bootcamp';

export interface CourseProgram {
  id: CourseProgramId;
  title: string;
  description: string;
  courseIds: string[];
  programHref: string;
}

export const COURSE_PROGRAMS: CourseProgram[] = [
  {
    id: 'python',
    title: 'Python',
    description: 'Первые проекты с ИИ, затем основы Python. AI-инженерия входит в обучение с нуля.',
    courseIds: ['python-standard', 'python-intensive'],
    programHref: '/courses/python/',
  },
  {
    id: 'javascript',
    title: 'Веб-разработка на JavaScript',
    description: 'Проекты с ИИ, затем HTML, CSS и JavaScript. AI-инженерия входит в обучение веб-разработке.',
    courseIds: ['javascript-standard', 'javascript-intensive'],
    programHref: '/courses/javascript/',
  },
  {
    id: 'computer-literacy',
    title: 'Компьютерная грамотность',
    description: 'Основы работы с компьютером для начинающих пользователей.',
    courseIds: ['computer-literacy'],
    programHref: '/courses/computer-literacy/',
  },
  {
    id: 'bootcamp',
    title: 'Буткемп Python',
    description: 'Интенсивная программа по Python с AI-инженерией. Для тех, кто уже знает основы языка.',
    courseIds: ['bootcamp'],
    programHref: '/courses/python-bootcamp/',
  },
];
